// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"2011abdc","498":"c8c66b55","526":"c78a179c","911":"de16b158"}[chunkId] + ".chunk.js";
};